<template>
  <div class="game-container clearfix">
    <LeftBar />
    <!-- <RightBar /> -->
    <iframe :src="gameUrl" @load="iframeLoad"></iframe>
    <PayPop />
    <GPayPop />
  </div>
</template>

<script>
import LeftBar from '~/components/play/LeftBar'
// import RightBar from '~/components/play/RightBar'
import { curBrowserSuportFlash, getThunderVersion } from '~/utils/util'
import PayPop from '~/components/logic-common/PayPop/wrapper'
import GPayPop from '~/components/logic-common/GPayPop/wrapper'
export default {
  layout: 'game-play',
  components: {
    LeftBar,
    // RightBar,
    PayPop,
    GPayPop
  },
  data() {
    return {
      gameUrl: '',
      needLoop: false,
      statTimer: null,
      statDurationList: [60, 300, 600, 1200, 1800, 3600],
      statDurationIndex: 0
    }
  },
  computed: {
    gameName() {
      return this.$store.state.play.playInfo.curServer
    }
  },
  watch: {
    gameName(val) {
      if (Object.keys(val).length > 0) {
        this.playSupportFlashStat()
        this.playStat()
      }
    }
  },
  created() {
    if (process.client) {
      if (this.$store.getters.isLogin) {
        this.$util.realNameAuth('play', this.$route.params.game_id)
      }
      this.getGameUrl(
        this.$route.params.game_id,
        this.$route.query.server_id,
        this.$route.query.server_code
      )
    }
  },
  mounted() {
    this.onMessage()
  },
  beforeRouteUpdate(to, from, next) {
    this.getGameUrl(to.params.game_id, to.query.server_id, to.query.server_code)
    next()
  },
  watchQuery: ['server_id'],
  methods: {
    onMessage() {
      const handler = (event) => {
        const [isErr, data] = this.$parseMessageData(event)
        if (!isErr && data && data.type === 'logined') {
          this.changeServerIdBySid(data)
        }
      }
      window.addEventListener('message', handler)
      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('message', handler)
        this.clearStatTimer()
      })
    },
    changeServerIdBySid({ gid, sid }) {
      return this.$request('getRoleByGid', {
        body: {
          gid,
          server_num: sid
        }
      }).then((data = {}) => {
        this.serverId = data.server_id
      })
    },
    iframeLoad(ev) {
      this.$hmtPush('play_page', 'game-load', 'params', {
        game_id: this.$route.params.game_id,
        server_id: this.$route.query.server_id,
        server_code: this.$route.query.server_code,
        game_url: this.gameUrl
      })
    },
    gameRole() {
      this.$request('gameRole', {
        body: {
          account: '',
          game_id: this.$route.params.game_id,
          server_id: this.serverId,
          client_type: this.$util.getClientType()
        }
      }).then(() => {
        this.$hmtPush('play_page', 'get-role', 'params', {
          game_id: this.$route.params.game_id,
          server_id: this.serverId,
          game_url: this.gameUrl
        })
      })
    },
    hearbeat() {
      this.gameRole()
      const timer = setInterval(() => {
        this.gameRole()
      }, 300000)
      this.$once('hook:beforeDestroy', () => {
        clearInterval(timer)
      })
    },
    loginReport(onClose) {
      if (!this.$store.getters.isLogin) return
      return this.$request('gameLoginReport', { method: 'post' }).then(
        (data = {}) => {
          onClose && onClose()
        }
      )
    },
    xunLeiHearbeat() {
      // 雷方要求心跳上报
      if (!this.$store.getters.isLogin) return
      const gameId = this.$route.params.game_id || ''
      const hearbeatTimer = setInterval(() => {
        const body = {
          runtime: 1,
          gameId: gameId.toString(),
          gameType: 1,
          platform: 'gamebox'
        }
        const secret = 'cm552qug45a6feu0fi20'
        body.timestamp = parseInt(Date.now() / 1000, 10).toString()
        body.key = this.$util.genSign(body, secret).toUpperCase()
        body.userId = this.$cookies.get('userid')
        window.$.ajax({
          url: '//youxi.xunlei.com/api/gamebox/v1/heartbeat',
          type: 'post',
          dataType: 'json',
          contentType: 'application/json',
          data: JSON.stringify(body),
          xhrFields: {
            withCredentials: true
          }
        })
      }, 10 * 1000)
      this.$once('hook:beforeDestroy', () => {
        clearInterval(hearbeatTimer)
      })
    },
    xunLeiLoginReport() {
      // 雷方要求数据上报
      if (!this.$store.getters.isLogin) return
      const gameId = this.$route.params.game_id || ''
      const serverId = this.serverId || ''
      const body = {
        reportType: 1,
        runtime: 1,
        playGamePayload: {
          gameId: gameId.toString(),
          gameType: 1,
          serverId: serverId.toString()
        },
        platform: 'gamebox',
        userId: this.$cookies.get('userid')
      }
      window.$.ajax({
        url: '//youxi.xunlei.com/api/gamebox/v1/data/report',
        type: 'post',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(body),
        xhrFields: {
          withCredentials: true
        }
      })
    },
    getGameUrl(game_id, server_id = '0', server_code = '') {
      if (server_id === '0') {
        this.innerGetGameUrl(game_id, server_id, server_code)
      } else {
        this.loginReport(() => {
          this.innerGetGameUrl(game_id, server_id, server_code)
        })
      }
    },
    innerGetGameUrl(game_id, server_id = 0, server_code = '') {
      this.$hmtPush('play_page', 'show', 'params', {
        game_id,
        server_id,
        server_code
      })
      if (!this.$store.getters.isLogin) {
        return this.$store.commit('app/setLoginPop', true)
      }
      this.$request('gameLogin', {
        body: {
          ...this.$route.query,
          game_id,
          server_id,
          server_code,
          client_type: this.$util.getClientType()
        }
      })
        .then((data = {}) => {
          this.gameUrl = data.login_url
          this.serverId = data.server_id
          if (this.$route.query.server_id === '0') {
            this.$router.replace({
              path: this.$route.path,
              query: {
                ...this.$route.query,
                server_id: data.server_id
              }
            })
          } else {
            this.hearbeat()
            this.loginReport()
            if (window !== window.top) {
              return
            }
            this.xunLeiHearbeat()
            this.xunLeiLoginReport()
          }
        })
        .catch((err) => {
          this.$notify({
            title: '提示',
            message: err.message,
            duration: -1
          })
        })
    },
    playSupportFlashStat() {
      if (curBrowserSuportFlash()) {
        this.$xlaGamePush('game_flash_plugin_load_result', {
          game_id: this.$route.params.game_id,
          game_name: this.$sget(this.gameName, 'game_title'),
          load_result: 'success',
          error_code: '0',
          client_version: getThunderVersion()
        })
      } else {
        this.$xlaGamePush('game_flash_plugin_load_result', {
          game_id: this.$route.params.game_id,
          game_name: this.$sget(this.gameName, 'game_title'),
          load_result: 'fail',
          error_code: '-1',
          client_version: getThunderVersion()
        })
      }
      this.playDurationStat(0)
    },
    playStat() {
      this.statTimer = setTimeout(() => {
        this.playDurationStat(
          this.statDurationList[this.statDurationIndex] / 60
        )
        this.clearStatTimer()
        this.statDurationIndex++
        if (this.statDurationIndex > 5) {
          return
        }
        this.playStat()
      }, this.statDurationList[this.statDurationIndex] * 1000)
    },
    playDurationStat(duration) {
      this.$xlaGamePush('game_heart_beat', {
        game_id: this.$route.params.game_id,
        game_name: this.$sget(this.gameName, 'game_title'),
        load_result: curBrowserSuportFlash() ? 'success' : 'fail',
        client_version: getThunderVersion(),
        heart_beat_type: duration
      })
    },
    clearStatTimer() {
      if (this.statTimer) {
        clearTimeout(this.statTimer)
        this.statTimer = null
      }
    }
  }
}
</script>

<style lang="scss" src="~/assets/scss/play.scss"></style>
